import { WidgetState } from "@/apps/StudentExchangeInformationColumnWidget/models/store-viewmodel"
import actions from "@/apps/StudentExchangeInformationColumnWidget/store/actions"
import mutations from "@/apps/StudentExchangeInformationColumnWidget/store/mutations"
import getters from "@/apps/StudentExchangeInformationColumnWidget/store/getters"

export default {
    state: new WidgetState,
    actions: actions,
    mutations: mutations,
    getters: getters
}
